import { render } from "./Container.vue?vue&type=template&id=6451b823"
const script = {}

import exportComponent from "/home/qunxiong/development/zhulu_inc/like_sea_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__